import { Container } from 'react-bootstrap';
import NoteBox from '../Layout/NoteBox';
import "./EvaluationTextContent.css";

const EvaluationTextContent = (props) => {
  return(
    <div id="evaluation-text-content">
      <Container fluid className="con-no-pad">
        <section id="section1">
          <NoteBox>
            <span>We will judge all submissions on a combination of the following oracle metrics:</span>
            <ul>
              <li>
                Bias
              </li>
              <li>
                Absolute bias
              </li>
              <li>
                Root mean squared error
              </li>
              <li>
                Uncertainty interval coverage
              </li>
              <li>
                Uncertainty interval width
              </li>
            </ul>
          </NoteBox>
          <span>
            For overall, yearly, and subgroup SATTs, these metrics will be averaged across the 200 realizations 
            of each DGP. For practice-level SATTs, for each DGP, these metrics will be averaged across practices 
            and across realizations. Note that the root mean squared error of the practice-level SATTs corresponds 
            to the PEHE (precision in estimation of heterogeneous effects) metric used in previous ACIC competitions.
          </span>
        </section>
      </Container>
    </div>
  )
}

export default EvaluationTextContent;
